import { ComponentInstall } from "../../utils";
import ScrollPageButtons from "./src";

export default ComponentInstall(ScrollPageButtons);
